import React from 'react'
import styles from './TextsListColumn.module.scss'
import CustomText from '../../CustomText/CustomText'

const TextsListColumn: React.FC<{ texts: string[] }> = ({ texts }) => {
  return (
    <div className={styles.content}>
      {texts.map((text, idx) => (
        <CustomText
          key={idx}
          label={text}
          type='secondary'
        />
      ))}
    </div>
  )
}

export default TextsListColumn
